export const SUPPORT_EMAIL = 'vivian.florida@gmail.com';
export const SUPPORT_PHONE_DISPLAY = '641-451-4761';
export const SUPPORT_PHONE_TEL = '+16414514761';
export const SUPPORT_PHONE_IN_DISPLAY = '+91 80 4701 1000';
export const SUPPORT_PHONE_IN_TEL = '+918047011000';
export const PRIVACY_POLICY_URL = 'https://sarthi-taxi-hiring.netlify.app/privacy';
export const SUPPORT_WEB_URL = 'https://sarthi-taxi-hiring.netlify.app/support';
